// extracted by mini-css-extract-plugin
module.exports = {"radioButton":"RadioButton_radioButton__2ltpi","label":"RadioButton_label__2CE9z","primaryText":"RadioButton_primaryText__2dnYj","secondaryText":"RadioButton_secondaryText__tk0Wl"};